module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"interview":"AI დასკვნა","interviewInited":"მოთხოვნილია","interviewActive":"მიმდინარეობს","interviewFinished":"მზადაა","interviewCancelled":"გაუქმებულია"},"en":{"interview":"AI Results are","interviewInited":"Requested","interviewActive":"In Progress","interviewFinished":"Ready","interviewCancelled":"Cancelled"}}')
  delete Component.options._Ctor
}
